import { MOBILE_SCREEN, useDeviceType } from '@travel/traveler-core/hooks';
import { cx } from '@travel/utils';

import styles from './accommodationPlanSkeleton.module.scss';

type Props = {
  skeletonItemCount?: number;
  itemPerGroup?: number;
  isPlanList: boolean;
};

const AccommodationPlanSkeleton = (props: Props) => {
  const { skeletonItemCount = 4, itemPerGroup = 1, isPlanList } = props;
  const deviceType = useDeviceType();
  const isSP = deviceType === MOBILE_SCREEN;

  return isSP ? (
    <div className={styles.skeletonMainContainer}>
      {[...Array(4)].map((_, index) => (
        <div key={index}>
          {isPlanList ? (
            <div
              className={cx(
                styles.skeletonContainer,
                skeletonItemCount === index + 1 && styles.skeletonContainerLast,
              )}
            >
              <div className={styles.skeletonHead}>
                <div className={styles.skeletonHeadTitleContainer}>
                  <span className={styles.skeletonHeadTitle} />
                </div>
                <div className={styles.skeletonHeadDescriptionContainer}>
                  <span className={styles.skeletonHeadDescription} />
                </div>
              </div>
              {[...Array(itemPerGroup)].map((_, index) => (
                <div key={index} className={styles.skeletonBody}>
                  <div className={styles.skeletonBodyMainCardContainer}>
                    <div className={styles.skeletonBodyImageContainer}>
                      {[...Array(2)].map((_, index) => (
                        <span key={index} className={styles.skeletonBodyImage} />
                      ))}
                    </div>
                    <div className={styles.skeletonBodyTitleContainer}>
                      {[...Array(2)].map((_, index) => (
                        <span key={index} className={styles.skeletonBodyTitle} />
                      ))}
                    </div>
                    <div className={styles.skeletonBodyDescriptionContainer}>
                      <span className={styles.skeletonBodyDescription} />
                    </div>
                  </div>
                  <div className={styles.skeletonBodyButtonContainer}>
                    <span className={styles.skeletonBodyButtonBigBlock} />
                    <span className={styles.skeletonBodyButtonSmallBlock} />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              className={cx(
                styles.skeletonContainerHotel,
                skeletonItemCount === index + 1 && styles.skeletonContainerHotelLast,
              )}
            >
              <div className={styles.skeletonBodyImageHotel} />
              <div className={styles.skeletonBodyDetails}>
                <div className={styles.skeletonBodyDetailsTop}>
                  <span className={styles.skeletonBodyTitleHotel} />
                  <span className={styles.skeletonBodyDescriptionHotel} />
                </div>
                <div className={styles.skeletonBodyDetailsBottom}>
                  <span className={styles.skeletonBodyButtonSmallBlockHotel} />
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  ) : (
    <div className={styles.skeletonMainContainer}>
      {[...Array(skeletonItemCount)].map((_, index) => (
        <div
          className={cx(
            styles.hotelInformationContainer,
            !isPlanList && styles.hotelInformationContainerHotel,
            skeletonItemCount === index + 1 && styles.hotelInformationContainerLast,
          )}
          key={index}
        >
          <div className={styles.hotelCardContainer}>
            {isPlanList && (
              <div className={styles.hotelTitleNameContainer}>
                <div className={styles.hotelNameArea}>
                  <div className={styles.nameAndReviews}>
                    <span className={styles.hotelNameBlock} />
                    <span className={styles.spotNameBlock} />
                  </div>
                </div>
              </div>
            )}
            <div className={styles.hotelDetailsContainer}>
              {[...Array(itemPerGroup)].map((_, index) => (
                <div
                  className={cx(
                    styles.hotelDetailsBoarder,
                    !isPlanList && styles.hotelDetailsBorderHotel,
                  )}
                  key={index}
                >
                  <div className={styles.picRoom}>
                    <span className={styles.pictureBLock} />
                  </div>
                  <div className={styles.hotelDescriptionContainer}>
                    <div
                      className={cx(
                        styles.tagFavoriteArea,
                        !isPlanList && styles.tagFavoriteAreaHotel,
                      )}
                    >
                      <span className={styles.tagAreaBlock} />
                    </div>
                    <div
                      className={cx(
                        styles.planAreaContainer,
                        !isPlanList && styles.planAreaContainerHotel,
                      )}
                    >
                      <span className={styles.planAreaBlock} />
                      <div className={styles.diningInformationContainer}>
                        <div className={styles.diningArea}>
                          <div className={styles.diningTextContainer}>
                            <span className={styles.diningAreaBlock} />
                          </div>
                        </div>
                      </div>
                    </div>
                    {isPlanList && (
                      <div className={styles.priceBoxContainer}>
                        <span className={styles.priceBoxBlock} />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AccommodationPlanSkeleton;
